import UserService from "@/services/user.service";

export function getCurrentMemberId(user) {
  const raw = user?.member_id ?? user?.id;
  if (raw == null || raw === "") return null;
  const n = parseInt(String(raw), 10);
  return Number.isNaN(n) ? null : n;
}

function pickCenters(response) {
  const data = response?.data?.data;
  if (Array.isArray(data?.list)) return data.list;
  if (Array.isArray(data)) return data;
  if (Array.isArray(response?.data?.list)) return response.data.list;
  return [];
}

function filterByInvigilator(list, memberId) {
  if (!Array.isArray(list) || !memberId) return [];
  return list.filter((center) => {
    const cid = parseInt(String(center?.invigilator_member_id ?? ""), 10);
    return !Number.isNaN(cid) && cid === memberId;
  });
}

async function safeFetch(params) {
  try {
    const response = await UserService.authGetRequest("qhls-exam-centers", params);
    return pickCenters(response);
  } catch (e) {
    return [];
  }
}

export async function fetchMyInvigilatorCenters(currentUser) {
  const memberId = getCurrentMemberId(currentUser);
  if (!memberId) return [];

  const zoneId = currentUser?.zone_id;
  const unitId = currentUser?.unit_id;

  const attempts = [];
  if (unitId && zoneId) attempts.push({ zone_id: zoneId, unit_id: unitId });
  if (zoneId) attempts.push({ zone_id: zoneId });
  if (unitId) attempts.push({ unit_id: unitId });
  attempts.push({});

  for (const params of attempts) {
    const list = await safeFetch(params);
    const mine = filterByInvigilator(list, memberId);
    if (mine.length) return mine;
  }
  return [];
}

export function qhlsInvigilatorCenterRoute(centers, currentUser) {
  const first = Array.isArray(centers) && centers.length ? centers[0] : null;
  const unitId = first?.unit_id ?? currentUser?.unit_id;
  if (!unitId) return null;
  return `/org/4/${unitId}/qhls-exam-center`;
}
